import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGraphSessionDistribution } from "./sessionDistributionAPI";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  Weeks: [],
  PercentVisitors: [],
  PercentBooking: [], 
  PercentBuying: [],
  GraphLabels: []
};

export const graphSessionDistribution = createAsyncThunk(
  "sessionDistribution/visitors",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-sessionDistribution`;
      const response = await fetchGraphSessionDistribution(dbpath, user, 'graph-sessionDistribution');
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const sessionDistributionSlice = createSlice({
  name: "sessionDistribution",
  initialState,
  reducers: {
    resetsessionDist: (state, action) => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphSessionDistribution.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphSessionDistribution.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        state.data = result;
        try {
          const resultData = sessionDistributionHandler(result);

          state.Weeks = resultData.weeks.reverse();
          state.PercentVisitors = resultData.percentVisitors.reverse();
          state.PercentBooking = resultData.percentBooking.reverse(); 
          state.PercentBuying = resultData.percentBuying.reverse();
          state.GraphLabels = resultData.graphLabels.reverse();
        }  catch (error) {
          // console.warn("sessionDistribution data not found!", error)
        }

      })
      .addCase(graphSessionDistribution.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      });
  },
});

export const { resetUniqueBnDevData,resetsessionDist } = sessionDistributionSlice.actions;


export const SelectStatus = (state) => state.sessionDistribution.status;
export const SelectWeeks = (state) => state.sessionDistribution.Weeks;
export const SelectPercentVisitors = (state) => state.sessionDistribution.PercentVisitors;
export const SelectPercentBooking = (state) => state.sessionDistribution.PercentBooking;
export const SelectPercentBuying = (state) => state.sessionDistribution.PercentBuying;
export const SelectGraphLabels = (state) => state.sessionDistribution.GraphLabels;


export default sessionDistributionSlice.reducer;


export const sessionDistributionHandler = (data) => {
  let result = {
    percentVisitors: [],
    percentBooking: [],
    percentBuying: [],
    graphLabels : [],
    weeks : []
  }

  for (let i = 0; i < Object.keys(data[0]).length; i++) {
    // Sets weeks array
    let tempWeek = Object.keys(data[0])
      [i].replace("(Week of", "")
      .replace(")", "");
    if (tempWeek !== "graph-options" && tempWeek !== "graph-backup") {
      result.weeks[i] = tempWeek;
    }
    // Percent of visitors and percent of visitors booking arrays
    result.percentVisitors[i] = Object.values(data[0])[i][0][0].data;
    result.percentBooking[i] = Object.values(data[0])[i][0][1].data;
    // Percent of visitors buying array
    if (Object.values(data[0])[i][0][2] !== undefined) {
      result.percentBuying[i] = Object.values(data[0])[i][0][2].data;
    } else {
      result.percentBuying[i] = [0];
    }
    result.graphLabels[i] = Object.values(data[0])[i][1];
  }

  return result;
}